// Utilidades de layout responsive (una sola base de código para vertical y horizontal).

// Diseño de referencia del juego.
export const BASE_W = 1280;
export const BASE_H = 720;

// Breakpoints por ancho: celular <480, tablet 480-1024, escritorio >1024.
export function getMode(W) {
  if (W < 480) return 'mobile';
  if (W <= 1024) return 'tablet';
  return 'desktop';
}

// Ajusta la cámara de una escena diseñada a 1280x720 para que quepa (tipo FIT)
// dentro del viewport actual, en cualquier orientación. Usado por menús/mapa.
export function fitDesign(scene, W = BASE_W, H = BASE_H) {
  const apply = () => {
    const cam = scene.cameras.main;
    const vw = scene.scale.width;
    const vh = scene.scale.height;
    const zoom = Math.min(vw / W, vh / H);
    cam.setZoom(zoom);
    cam.centerOn(W / 2, H / 2);
  };
  apply();
  scene.scale.on('resize', apply);
  scene.events.once('shutdown', () => scene.scale.off('resize', apply));
  scene.events.once('destroy', () => scene.scale.off('resize', apply));
}

// Calcula las bandas de layout del gameplay según la orientación.
// - Horizontal: el área de juego ocupa todo el viewport (como el diseño actual).
// - Vertical: pregunta arriba, área de juego 16:9 al centro, controles abajo.
//   El área de juego mantiene 16:9 para conservar EXACTAMENTE la jugabilidad y que
//   las tres respuestas de la Zona de Decisión sigan visibles.
export function getBands(W, H) {
  const portrait = H > W;
  if (!portrait) {
    return { portrait: false, top: 0, bottom: 0, playY: 0, playH: H, W, H };
  }
  const playH = Math.round((W * 9) / 16);
  const extra = Math.max(0, H - playH);
  const top = Math.round(Math.min(220, Math.max(156, extra * 0.45), Math.max(0, extra - 100)));
  return { portrait: true, top, bottom: H - top - playH, playY: top, playH, W, H };
}
